<script lang="ts">
	import { CartStep, cartStepOrderMap, cartStepPathMap, getCartStepName } from "../../stores/cart/CartStep.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import Icon from "../Icon.svelte";
	import check from "../../../../core/assets/icons/check-simple.svg?raw";
	import { getCartStore } from "../../contexts/cartStoreContextKey.js";

	export let currentStep: CartStep;
	export let nextStep: CartStep | undefined = undefined;
	export let disableNextSteps = false;

	const cartStore = getCartStore();
	const { TENANT_LOCALE } = getGlobalSettings();
	const steps = [CartStep.Overview, CartStep.PaymentDelivery, CartStep.Address] as const;

	$: cartStepIndex = cartStepOrderMap[$cartStore.value.step];
	$: currentStepIndex = cartStepOrderMap[currentStep];
</script>

<div class="mb-12 mt-[0.8125rem] flex items-center gap-2">
	{#each steps as step, index}
		{@const isFirstStep = index === 0}
		{@const currentlyAtStep = currentStep === step}
		{@const isNextStep = nextStep === step}
		{@const cartIsBeforeThisStep = cartStepIndex < index}
		{@const cartIsAfterThisStep = currentStepIndex > index || cartStepIndex > index}

		{#if !isFirstStep}
			<div class="bg-grey-200 h-[1px] w-2 sm:w-12"></div>
		{/if}

		{#if isNextStep && cartIsBeforeThisStep}
			<button
				type="submit"
				disabled={disableNextSteps}
				class="text-2xs text-secondary relative flex items-center gap-2 rounded-full border bg-white leading-5 sm:px-3"
			>
				<span class="hidden text-left text-black sm:inline-block">
					{getCartStepName(step, $cartStore.value, TENANT_LOCALE)}
				</span>
				<span
					class="text-2xs flex h-[1.375rem] w-[1.375rem] shrink-0 items-center justify-center rounded-full bg-slate-200 font-medium text-black transition-colors duration-300 hover:bg-slate-300 sm:hidden md:h-[1.125rem] md:w-[1.125rem]"
				>
					{index + 1}
				</span>
			</button>
		{:else}
			{@const disabled = currentlyAtStep || cartIsBeforeThisStep}
			<a
				href="/{cartStepPathMap[step][TENANT_LOCALE]}"
				class="text-2xs text-secondary relative flex items-center gap-2 rounded-full border bg-white px-3 leading-5 {currentlyAtStep
					? ' !border-primary sm:!px-3'
					: ''} {disabled ? 'pointer-events-none cursor-default' : ''} {cartIsAfterThisStep
					? 'pl-0.5 sm:pl-1'
					: ''} {cartIsAfterThisStep && !currentlyAtStep ? '!p-0.5 sm:!px-3 sm:!py-0' : ''} {!currentlyAtStep &&
				!cartIsAfterThisStep
					? '!px-0 sm:!px-3'
					: ''}"
			>
				{#if cartIsAfterThisStep}
					<span
						class="text-2xs bg-tertiary flex aspect-square h-4 shrink-0 items-center justify-center rounded-full text-white sm:h-3"
					>
						<Icon icon={check} class="h-3 text-white" />
					</span>
				{/if}
				<span
					class="text-left {currentlyAtStep ? '!text-primary' : 'text-secondary'}"
					class:hidden={!currentlyAtStep}
					class:sm:inline-block={!currentlyAtStep}
				>
					{getCartStepName(step, $cartStore.value, TENANT_LOCALE)}
				</span>
				{#if !currentlyAtStep && !cartIsAfterThisStep}
					<span
						class="text-2xs flex h-[1.375rem] w-[1.375rem] shrink-0 items-center justify-center rounded-full bg-slate-200 font-medium text-black transition-colors duration-300 hover:bg-slate-300 sm:hidden md:h-[1.125rem] md:w-[1.125rem]"
						class:text-secondary-300={cartIsBeforeThisStep}
					>
						{index + 1}
					</span>
				{/if}
			</a>
		{/if}
	{/each}
</div>
